/**
 * SystemOverview Component
 * 
 * This component manages the state for the SystemOverview page, allowing users to switch 
 * between different menus and submenus. The active menu is determined by the URL parameter `menu`, 
 * defaulting to 'showDevices' if no parameter is provided.
 */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import HomePage from './SystemOverview/Home';
import Navigationbar from './Navigationbar';
import ShowDevices from './SystemOverview/ShowDevices'
import { getFreshToken, get } from '../custom_libraries/serverRequests';
import globalVariables from '../custom_libraries/globalVariables';
import urls from "../custom_libraries/urls";
import withNavigate from '../Global_files/WithNavigate'; 

const SystemOverview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { menu } = useParams(); //Hooks:  * - `useParams`: Retrieves the `menu` parameter from the URL.  * - `useState`: Manages the component's local state for the active menu and submenu.
  const [activeMenu, setActiveMenu] = useState(menu || 'home'); //State:    * - `activeMenu`: Tracks the currently selected menu. Initialized with the `menu` URL parameter or defaults to 'aiEngineSettings'.
  const [activeSubmenu, setActiveSubmenu] = useState(null); // State: `activeSubmenu`: Tracks the currently selected submenu. Initially set to `null`.
  const [dataAvailable, setDataAvailable] = useState(null);
  const [loading, setLoading] = useState(true); // Track loading state
  // Sync `activeMenu` with `menu` parameter --> use this only for internal navigation within the same screen tab (e.g. switching between tabs by onclick event)
  useEffect(() => {
    validateSignedIn()
    getMatrixCount()
    setActiveMenu(menu || "home");
  }, [menu]);

  const handleMenuClick = (menu) => {   //Updates the `activeMenu` state to the selected menu.
    setActiveMenu(menu);    
  };

  const handleSubmenuClick = (submenu) => { //Updates the `activeSubmenu` state to the selected submenu.
    setActiveSubmenu(submenu);
  };

//   componentWillUnmount() {
//     // fix Warning: Can't perform a React state update on an unmounted component
//     this.setState = () => {
//         return;
//     };
// }

const validateSignedIn = async () => {
    let is_fresh_token = await getFreshToken()
    if (!is_fresh_token) {
        navigate("/");
        return
    }
}

  const getMatrixCount = async () => {
    try {
      setLoading(true); // Show loading state before API call
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const response = await get(urls.STATUS_MATRIX, headers); // Perform the API call using the constructed URL
        console.log("API Response for getMatrixCount:", response);
       
      if (response?.devices?.total === 0 ) {
        setDataAvailable(false);
        console.error(" fetching getMatrixCount from API:");
      }
      else {
        setDataAvailable(true);
        console.error(" fetching getMatrixCount from API:");
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
    }finally {
      setLoading(false); // Hide loading state after API response/error
  }
  };

  return (
    <div >
        <Navigationbar />
      {/* {dataAvailable === true ?
        (
        <>
          <div className="system-overview-content-container">
            <div className="system-overview-page-content">
              {activeMenu === 'home' && <HomePage />}        
            </div>
          </div>
        </>
        ) : (
          <>
            <div style={{marginLeft:'15%', display:'flex', justifyContent:'center', alignContent:'center'}}><h1>  No device is configured ! Setup devices or contact the Admin. </h1></div>
          </>
        )
      } */}
      {loading ? (
            <h2 style={{marginLeft:'15%', display:'flex', alignContent:'center'}}>Loading...</h2>  // Show loading indicator instead of incorrect message
        ) : dataAvailable ? (
            <div className="system-overview-content-container">
                <div className="system-overview-page-content">
                    {activeMenu === 'home' && <HomePage />}
                </div>
            </div>
        ) : (
            <div style={{marginLeft:'15%', display:'flex', justifyContent:'center', alignContent:'center'}}>
                <h1>No device is configured! Setup devices or contact the Admin.</h1>
            </div>
        )}
    </div>
  );
};

export default SystemOverview;
